import { Box, Typography } from "@mui/material";
import React from "react";
import gifConnecting from "../assets/image/gifConnecting.gif";
import imageShowProf from "../assets/image/imageShowProf.png";

export default function CardTitleGroup({name,pic,titr,onClick,profile}) {
  return (
    <>
     
        <Box
          padding="9px"
          width="280px"
          pr="20px"
          borderRadius="22px"
          bgcolor={"white"}
        >
          <Box
            alignItems="center"
            justifyContent={"space-between"}
            display={"flex"}
          >
            <Box alignItems="center"
            justifyContent={"space-between"}
            display={"flex"} >

            <img
              style={{
                  width: "40px",
                  height: "40px",
                  borderRadius: "50%",
                  border: "solid 1px #126E839C",
                  objectFit:"cover"
                }}
                src={pic}
                />
            <Box mr='10px' >
              <Typography fontSize={"14px"}>
                {name}
              </Typography>
              <Typography fontSize={"14px"} color="var(--emr-disable)">
                {titr}
              </Typography>
                </Box>
            </Box>
            <img onClick={onClick} src={profile?imageShowProf: gifConnecting} style={{ width: "40px",cursor:"pointer" }} />
          </Box>
          
        </Box>
     
    </>
  );
}
